import React from "react";
import { Stack, Typography, Box, Chip, IconButton } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import ClearIcon from "@mui/icons-material/Clear";
import { styles } from "./FilterNSearchBar.styles";

export const FilterBarChips = ({
  filterLabel = "",
  filters = [],
  selectedFilter = null,
  onFilterChange,
  onClearFilters,
  showClear = false,
}) => (
  <Stack direction="row" alignItems="center" spacing={1}>
    <FilterListIcon sx={{ color: "#6B7280", fontSize: 20 }} />
    <Typography
      variant="body2"
      color="#374151"
      fontWeight={600}
      sx={{ whiteSpace: "nowrap" }}
    >
      {filterLabel}
    </Typography>
    <Box
      sx={{
        overflowX: "auto",
        display: "flex",
        gap: 1,
        flexWrap: "nowrap",
        py: 0.5,
      }}
    >
      {filters.map((filter) => (
        <Chip
          key={filter}
          label={filter}
          onClick={() =>
            onFilterChange(selectedFilter === filter ? null : filter)
          }
          sx={
            selectedFilter === filter
              ? styles.filterChipSelected
              : styles.filterChip
          }
        />
      ))}
    </Box>
    {showClear && (
      <IconButton size="small" onClick={onClearFilters}>
        <ClearIcon fontSize="small" />
      </IconButton>
    )}
  </Stack>
);
